import "./InstallerOpportunity.module.css";
import Header from "@/reusable_sections/Header";
import YourPathToGrowth from "./sections/YourPathToGrowth";
import SupportTraining from "./sections/SupportTraining";
import InstallerSuccessStories from "./sections/InstallerSuccessStories";
import Footer from "@/reusable_sections/Footer";
export default function InstallerOpportunityPage() {
  return <div>
      <Header />
      <YourPathToGrowth />
      <SupportTraining />
      <InstallerSuccessStories />
      <Footer />
    </div>;
}